import React, { useEffect, useRef } from 'react';

function Dialog({ title, onClose, locked = false, children }) {
  const lockedRef = useRef(locked);
  lockedRef.current = locked;

  useEffect(() => {
    const onKey = (event) => {
      if (event.key !== 'Escape') return;
      if (lockedRef.current) {
        event.preventDefault();
        return;
      }
      onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="dialog-backdrop" onMouseDown={locked ? undefined : onClose}>
      <div
        className="dialog"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        aria-busy={locked}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <h2 className="dialog-title">{title}</h2>
        {children}
      </div>
    </div>
  );
}

export default Dialog;